export const showToastNotification= (alertType,userName,actionButton) => ({ type: 'SHOW_TOAST_NOTIFICATION',alertType,userName,actionButton})
export const hideToastNotification= () => ({ type: 'HIDE_TOAST_NOTIFICATION'})

 